import React from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

const BannerLogin = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: 'ease-in-out'
  }

  const banners = [
    '/login/banner1.jfif',
    '/login/banner2.jfif',
    '/login/banner3.jfif'
  ]

  return (
    <div className='banner-pages'>
      <Slider {...settings}>
        {banners.map((image, index) => (
          <div className='item-banner1' key={`banner-${index}`}>
            <Link to='#'>
              <div className='banner-img'>
                <img src={image} alt={`Slide ${index + 1}`} loading='lazy' />
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default BannerLogin
